"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const usergeek_ic_js_1 = require("usergeek-ic-js");
const MixpanelAnalytics_1 = require("src/hello_assets/src/util/analytics/MixpanelAnalytics");
const isTest = !!process.env.IS_TEST_SERVER;
const trackEventToConsumer = (eventName) => {
    if (!isTest) {
        usergeek_ic_js_1.Usergeek.trackEvent(eventName);
        usergeek_ic_js_1.Usergeek.flush();
    }
    else {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("Analytics: ", eventName);
        }
        usergeek_ic_js_1.Usergeek.trackEvent(eventName);
        usergeek_ic_js_1.Usergeek.flush();
    }
    MixpanelAnalytics_1.MixpanelAnalytics.trackBusinessAction(eventName);
};
exports.Analytics = {
    trackViewDashboard: () => trackEventToConsumer("ViewDashboard"),
    trackCreateProject: () => trackEventToConsumer("CreateProject"),
    trackInviteMember: () => trackEventToConsumer("InviteMember"),
    trackViewRetention: () => trackEventToConsumer("ViewRetention"),
    trackViewEvents: () => trackEventToConsumer("ViewEvents"),
    trackViewFunnel: () => trackEventToConsumer("ViewFunnel"),
};
